import React from 'react';
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import 'react-select/dist/react-select.css';

const Select = (props) => {
	const {list, value, onChange, matchProp, disabled, clearable, searchable, simpleValue, multi, ...rest} = props;

	return (
		<ReactSelect
			options={list}
			value={value}
			onChange={onChange}
			matchProp={matchProp}
			disabled={disabled}
			clearable={clearable}
			searchable={searchable}
			simpleValue={simpleValue}
			multi={multi}
			{...rest}
		/>
	);
};

Select.defaultProps = {
	matchProp: 'label',
	disabled: false,
	clearable: false,
	searchable: true,
	simpleValue: true,
	multi: false
};

Select.propTypes = {
	list: PropTypes.array.isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
	onChange: PropTypes.func.isRequired,
	matchProp: PropTypes.string,
	disabled: PropTypes.bool,
	clearable: PropTypes.bool,
	searchable: PropTypes.bool,
	multi: PropTypes.bool
};

export default Select;